// EquiposSinMovimientoPage.tsx

import { a11yProps } from "@/shared";
import { CustomTabPanel, SingleTableBoxScene } from "@/shared/components/ui";
import { Box, Tabs, Tab, TextField, Button, Divider, Typography } from "@mui/material";
import { useState } from "react";
import TableEquiposSinMovimiento from "../../components/table-equipos-sin-movimiento/TableEquiposSinMovimiento";
import TableMaterialesSinMovimiento from "../../components/table-materiales-sin-movimiento/TableMaterialesSinMovimiento";

export default function EquiposSinMovimientoPage() {
  const [valueTab, setValueTab] = useState(0);
  const [fechaDesde, setFechaDesde] = useState("");
  const [fechaHasta, setFechaHasta] = useState("");
  const [fechaDesdeApplied, setFechaDesdeApplied] = useState("");
  const [fechaHastaApplied, setFechaHastaApplied] = useState("");

  const canSearch = !!fechaDesde && !!fechaHasta;

  const handleSearch = () => {
    setFechaDesdeApplied(fechaDesde);
    setFechaHastaApplied(fechaHasta);
  };

  return (
    <SingleTableBoxScene title={"Equipos / Materiales Sin Movimientos"}
      py={2}
      visibleReport={true}
    >
      <Box sx={{ bgcolor: 'background.paper', borderBottom: 1, borderColor: 'divider' }}>
        <Tabs
          value={valueTab}
          onChange={(_event: React.SyntheticEvent, newValue: number) => {
            setValueTab(newValue);
          }}
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
          aria-label="scrollable force tabs equipossinmovimiento"
          sx={{
            minHeight: 52,
            '& .MuiTab-root': {
              fontSize: '0.95rem',
              fontWeight: 600,
              minHeight: 52,
              textTransform: 'none',
              px: 3,
            },
            '& .MuiTabs-indicator': {
              height: 3,
              borderRadius: '3px 3px 0 0',
            },
          }}
        >
          <Tab label="Equipos" {...a11yProps(0)} />
          <Tab label="Materiales" {...a11yProps(1)} />
        </Tabs>
      </Box>

      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 2,
          flexWrap: 'wrap',
          mt: 5,
          mb: 5,
        }}
      >
        <Typography variant="subtitle1" sx={{ width: '100%', fontWeight: 600, color: 'text.secondary' }}>
          Fechas de ultimo movimiento
        </Typography>
        <TextField
          label="Fecha desde"
          type="date"
          value={fechaDesde}
          onChange={(e) => setFechaDesde(e.target.value)}
          InputLabelProps={{ shrink: true }}
          size="medium"
        />
        <TextField
          label="Fecha hasta"
          type="date"
          value={fechaHasta}
          onChange={(e) => setFechaHasta(e.target.value)}
          InputLabelProps={{ shrink: true }}
          size="medium"
        />
        <Button
          variant="contained"
          onClick={handleSearch}
          disabled={!canSearch}
          size="medium"
          sx={{ height: 40, px: 3, fontWeight: 600, textTransform: 'none' }}
        >
          Consultar
        </Button>
      </Box>

      <Divider sx={{ mb: 2 }} />

      <CustomTabPanel value={valueTab} index={0}>
        <TableEquiposSinMovimiento
          fechaDesdeApplied={fechaDesdeApplied}
          fechaHastaApplied={fechaHastaApplied}
        />
      </CustomTabPanel>
      <CustomTabPanel value={valueTab} index={1}>
        <TableMaterialesSinMovimiento
          fechaDesdeApplied={fechaDesdeApplied}
          fechaHastaApplied={fechaHastaApplied}
        />
      </CustomTabPanel>
    </SingleTableBoxScene>
  );
}